// tiktokPixel.js

export const initTikTokPixel = (pixelId) => {
  if (!pixelId) return;

  if (!window.ttq) {
    const initTikTok = (w, d, t) => {
      w.TiktokAnalyticsObject = t;

      const ttq = (w[t] = w[t] || []);

      ttq.methods = [
        "page",
        "track",
        "identify",
        "instances",
        "debug",
        "on",
        "off",
        "once",
        "ready",
        "alias",
        "group",
        "enableCookie",
        "disableCookie",
      ];

      ttq.setAndDefer = function (target, method) {
        target[method] = function () {
          target.push(
            [method].concat(Array.prototype.slice.call(arguments, 0))
          );
        };
      };

      for (let i = 0; i < ttq.methods.length; i += 1) {
        ttq.setAndDefer(ttq, ttq.methods[i]);
      }

      ttq.instance = function (pixelId) {
        const instance = ttq._i[pixelId] || [];

        for (let i = 0; i < ttq.methods.length; i += 1) {
          ttq.setAndDefer(instance, ttq.methods[i]);
        }

        return instance;
      };

      ttq.load = function (pixelId, options) {
        const url =
          "https://analytics.tiktok.com/i18n/pixel/events.js";

        ttq._i = ttq._i || {};
        ttq._i[pixelId] = [];
        ttq._i[pixelId]._u = url;

        ttq._t = ttq._t || {};
        ttq._t[pixelId] = +new Date();

        ttq._o = ttq._o || {};
        ttq._o[pixelId] = options || {};

        const script = d.createElement("script");

        script.type = "text/javascript";
        script.async = true;
        script.src = `${url}?sdkid=${pixelId}&lib=${t}`;

        const firstScript = d.getElementsByTagName("script")[0];

        if (firstScript && firstScript.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          d.head.appendChild(script);
        }
      };
    };

    initTikTok(window, document, "ttq");
  }

  window.ttq.load(pixelId);
  window.ttq.page();
};

export const trackTikTok = (event, data = {}) => {
  if (!window.ttq) return;

  window.ttq.track(event, data);
};